import qs, { ParsedQs } from 'qs';
import { BASE_ROUTER, ENV } from 'config/index';
import Cookies from "js-cookie";
import moment from "moment";
import { PAY_HOST } from 'config/url';
// import { commonStore } from 'stores';

/**
 * 获取路径query参数
 */
export const getQuery = (): any => qs.parse(window.location.search.substring(1));

// 获取装修url
const getPreviewUrl = (env: 'dev' | 'test' | 'qa') => {
  let url: string = '';
  switch (env) {
    case "dev":
      url = 'http://dev-deco.fleshopy.com/fitment'
      break;
    case "qa":
      url = 'http://qa-deco.fleshopy.com/fitment';
      break;
    default:
      url = 'https://deco.fleshopy.com/fitment'
  }
  return url;
}

// 获取h5url
export const getH5Url = (siteId: string, decorationId: string ) => {
  let url: string = `https://${siteId}`;
  let params = `fleshopy.com/tiny/${decorationId}?urlFrom=weapp&firstPage=goods&isPc=yes&type=disable_link`
  switch (ENV) {
    case "dev":
      url = `${url}.dev-shop.${params}`
      break;
    case "qa":
      url = `${url}.qa-shop.${params}`;
      break;
    default:
      url = `${url}.shop.${params}`;
  }
  return url;
};

// 获取会员端saas管理后台
export const getMemberSiteK = (siteId: string, authorityToken?:string) => {
  let url = `site.fleshopy.com`;
  switch (ENV) {
    case "dev":
      url = `http://dev-${url}`
      break;
    case "qa":
      url = `http://qa-${url}`;
      break;
      case "test":
      url = `http://qa-${url}`;
      break;
    default:
      url = `https://${url}`;
  }
  return `${url}/${siteId}/survey?token=${authorityToken}&from=peliten`;
}

// 获取会员端saas管理后台
export const getMemberSite = (siteId: string) => {
  let url = `site.fleshopy.com`;
  switch (ENV) {
    case "dev":
      url = `http://dev-${url}`
      break;
    case "qa":
      url = `http://qa-${url}`;
      break;
    default:
      url = `https://${url}`;
  }
  return `${url}/${siteId}/survey?token=${Cookies.get("token")}&from=peliten`;
}

// 获取h5页面

export const copyJudge = (siteId?: number) => {
  let _url = "";
  switch (ENV) {
    case "dev":
      _url = `http://${siteId
      }.dev-shop.fleshopy.com`;
      break;
    case "qa":
      _url = `https://${
        siteId
      }.qa-shop.fleshopy.com`;
      break;
    default:
      _url = `https://${
        siteId
      }.shop.fleshopy.com`;
  }
  return _url;
};


export const getSitePreview = (siteId: string, decorationId: string, loginLink?: string) => {
  // 获取站点装修地址 fitment /saas/preview
    const url = getPreviewUrl (ENV as any);
    const _url = `${url}/${siteId}?token=${Cookies.get(
        "token"
      )}&tinyId=${decorationId}&origin=${encodeURIComponent(window.location.href)}&from=peliten&$loginLink=${loginLink}`;
    return _url;
};

export const siteDecorationUrl = (siteId: string,decoration: string) => {

}


// 将小写字母横杆转化为小驼峰如 a-bb 转为 aBb
export function transformsToUpperCase(str: string) {
  const transformStr = str.replace(/-(\w)/g,function($,$1){
  return $1.toUpperCase();
  });
  return transformStr;
};

// 遍历路由
export const traverse = (arr: Array<any>, key: string) => {
  if (!arr) return;
  for (let i = 0; i < arr.length; i++) {
    arr[i][key] = transformsToUpperCase(arr[i][key] as string);
    if (arr[i].children) {
      traverseChildren(arr[i].children, key)
    }
  };
  return arr;
};

// 遍历子路由
const traverseChildren = (arr: Array<any>, key: string) => {
  if (!arr) return;
  traverse(arr, key);
};

/**
 * 时间戳转换
 */
export const formatTime = (time: any, fmt = "YYYY-MM-DD HH:mm:ss") => {
  return time ? moment(time).format(fmt) : "";
};


// 下载为文件
export function downloadFile(
  data: any, 
  type: string = "vnd.ms-excel", 
  fileName: string = ""
  ) {
  const blob = new Blob([data], { type: `application/${type}` });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download =
    fileName || formatTime(new Date(), "YYYYMMDDHHmmss") + "下载文件";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export const downloadTemplateDOC = (docUrl: string, fileName?: string, fileType?: string) =>{
  const type = fileType || "vnd.ms-excel"
  fetch(docUrl).then((response)=> {
    return response.blob()
  }).then((res: any) => {
    downloadFile(res, type, fileName)
  });
}

// 分割数字
export const thousands = (num: number | string) => {
  var str = num.toString();
  var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg,"$1,");
}

export const getQueryString = (name: string) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
      return decodeURIComponent(r[2]);
  };
  return null;
}

// 跳转登录地址
export function handleGotoLogin  ()  {
  window.location.href = `${BASE_ROUTER}/login?redirectUrl=${encodeURIComponent(window.location.origin + window.location.pathname)}`
};

// 跳转到支付页面
export function handleGotoPay (payBillIds: string[], redirectUrl: string) { 
  console.log(`${PAY_HOST}?token=${Cookies.get('token')}&payBillIds=${payBillIds.join(',')}&redirectUr=${encodeURIComponent(redirectUrl)}`)
  window.location.href = `${PAY_HOST}/?token=${Cookies.get('token')}&payBillIds=${payBillIds.join(',')}&redirectUrl=${encodeURIComponent(redirectUrl)}&autoRedirect=1`
}

// 复制链接
export  const handleCopyLinkUrlClick = (siteId: number) => {
  const divElm = document.createElement('div')
  divElm.style.setProperty('opacity', '0')
  divElm.style.setProperty(' transform', 'scale(0)')
  divElm.innerHTML = copyJudge (siteId)
  document.body.appendChild(divElm)
  const range: Range = document.createRange()
  range.selectNode(divElm as HTMLSpanElement);
  const selection: Selection = getSelection() as Selection
    if (selection.rangeCount > 0) {
      selection.removeAllRanges()
    }
    
    selection.addRange(range);
    document.execCommand('copy');
    document.body.removeChild(divElm)
};

// 对后端传入的标签进行处理
export const formmatterTags = (values: any) => {
  const result: any = {};
  Object
    .keys(values)
      .forEach((prop: any) => {
        result[prop] = values[prop]
          .map((tag: any) => {
            const { tagName, tagCategoryId } = tag;
            return {
              ...tag,
              labelName: tagName,
              labelTypeId: tagCategoryId,
              labelTypeName: prop,
            }
          })
      });
  return result;
};

export const json2params = (json: any, slice = '&') => {
  return Object.keys(json)
  .reduce((acc, item) => {
  return String(acc) + item + '=' + json[item] + slice;
  }, '')
  .slice(0, -1);
  }

  // 获取h5url
export const getH5UrlNew = (siteId: any) => {
  let _url = "";
  switch (ENV) {
    case "dev":
      _url = `http://${siteId
      }.dev-shop.fleshopy.com`;
      break;
    case "qa":
      _url = `https://${
        siteId
      }.qa-shop.fleshopy.com`;
      break;
    case "test":
      _url = `https://${
        siteId
      }.qa-shop.fleshopy.com`;
      break;
    default:
      _url = `https://${
        siteId
      }.shop.fleshopy.com`;
  }
  return _url;
};